import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import IGOnDemand from "../../../assets/img/Featured/app-ondemand-food.png";
import IGQuickPay from "../../../assets/img/Featured/app-qr-quickpay.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";
const LoungePage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page loungePage">
            <Header />
            <div className="page-header">Golf Course</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Club & Lounge</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Deliver comfortable, efficient club &
                    lounge experiences. With member information at
                    their fingertips, servers know food preferences,
                    allergies, personal celebrations and more.{'\n\n'}
                </div>
                <div className="std-text">
                    Ensure that transactions apply member account
                    rules, pricing and family benefits, and that
                    accounts are charged appropriately.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Golf - Club & Lounge", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                    <img src={InfoGenesis} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Golf - Club & Lounge", "IG OnDemand");
                    addFlow("IG OnDemand");
                    navigate("/solutions/ig-on-demand")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    <img src={IGOnDemand} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Golf - Club & Lounge", "IG Quick Pay");
                    addFlow("IG Quick Pay");
                    navigate("/solutions/ig-quick-pay")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Quick Pay
                    </div>
                    <img src={IGQuickPay} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default LoungePage;